import axios from 'axios';
import { getAuthToken } from '../auth-token';
import { clearAuthData, addToFailedQueue } from '../auth-event';

const baseURL =
  process.env.NEXT_PUBLIC_API_V2_BASE_URL ||
  (process.env.NEXT_PUBLIC_ENVIRONMENT === 'production'
    ? 'https://admin-lb.clickster.io/api/v2'
    : 'https://s-admin-lb.clickster.io/api/v2');

export const API_V2 = axios.create({
  baseURL,
});

API_V2.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/**
 * Middleware to handle invalid or expired tokens
 * Shows auth modal when 401 Unauthorized is detected
 * Queues failed requests for retry after login
 */
API_V2.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config;

    // Only handle 401 errors that haven't been retried yet
    // Skip auth clearing if the request has skipAuthClear flag
    if (error.response && error.response.status === 401 && !originalRequest._retry && !originalRequest.skipAuthClear) {
      originalRequest._retry = true;

      // Clear auth data from storage
      clearAuthData();

      // Queue the failed request and show auth modal
      return addToFailedQueue(originalRequest);
    }

    return Promise.reject(error);
  },
);
